import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IUser } from '@interfaces/IUser';
import { IAppState } from '@myStore/app.state';
import { selectTheme } from '@myStore/theme/theme.selector';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

class DialogData {
  title!: string;
  content!: never | null;
  student?: IUser;
  buttonText?: string;
  panelClass?: string;
  loading$?: Observable<boolean>;
  success$?: Observable<boolean>;
  onSubmit?: () => void;
  afterClosed?: () => void;
  cancel?: () => void;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.sass'],
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  public theme = 'light';

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private _store: Store<IAppState>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit() {
    this._store
      .pipe(select(selectTheme), takeUntil(this.destroy$))
      .subscribe(theme => {
        this.theme = theme;
        const panelClass = this.dialogRef.componentInstance?.data.panelClass;

        // if (theme === 'dark') {
        //   this.dialogRef.addPanelClass('custom-modal');
        // }
        //
        if (theme === 'dark' && panelClass) {
          this.dialogRef.addPanelClass(panelClass);
        }
      });

    this.data.success$?.pipe(takeUntil(this.destroy$)).subscribe(success => {
      if (success) {
        this.dialogRef.close();

        if (this.data.afterClosed) {
          this.data.afterClosed();
        }
      }
    });
  }

  onCancel(): void {
    if (this.data.cancel) {
      this.data.cancel();
    }

    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.data.onSubmit) {
      this.data.onSubmit();
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
